import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { RootService } from 'src/app/shared/services/root.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-kyc-profile',
  templateUrl: './kyc-profile.component.html',
  styleUrls: ['../profile/profile.component.scss']
})
export class KycProfileComponent implements OnInit {
  selectedIdDocNo: any = '';
  profileFormGroup!: FormGroup;
  selectedAddDocNo: any = '';
  kycKarzaRes: any;
  userKYCDetails: any;
  isIdKYCDone: boolean = false;
  isAddKYCDone: boolean = false;
  kycAddr: any;
  environment1 = environment.s3bucket.url;
  sub: Subscription = new Subscription
  productLoaded: boolean = false
  selectedAddressProof: any = null;
  selectedIDProof: any = null;
  userData: any;
  kycAddOne: any;
  kycAddrTwo: any
  page: any;
  stateList: any;
  districtList: any = [];
  isAllowToEdit: boolean = false;

  addressProofList = [
    // { name: "Passport", value: "passport" },
    { name: "Aadhar Card", value: "aadhar_card" },
    // { name: "Ration Card", value: "ration_card" },
    // { name: "Driving License", value: "driving_license" },
    // { name: "Utility Bill", value: "utility_bill" },
  ];
  idProofList = [
    { name: "Pan Card", value: "id_pancard" },
    // { name: "Voter ID Card", value: "id_voter_card" },
  ];
  constructor(private toastrService: ToastrService, private apiService: ApiService,  private spinner: NgxSpinnerService,
    private secureService: RootService,private fb: FormBuilder, private regexService: RegexService, private router: Router,
    ) { }

  ngOnInit(): void {
    this.selectedAddressProof = "aadhar_card"
    this.selectedIDProof = "id_pancard";
    this.getUserDetails()
  }

  submitKYC() {
    if (!this.selectedAddressProof && !this.selectedIDProof) {
      this.toastrService.warning("Select proof type from Address and ID proof and Enter Document No.");
      return;
    } else {
      if ((this.userData.account_type === 'Individual') && this.selectedAddressProof && this.selectedAddDocNo == '') {
        this.toastrService.warning("Insert Address Proof Document No.");
        return;
      }
      else if (!this.selectedAddressProof && this.selectedAddDocNo != '' && (this.userData.account_type === 'Individual')) {
        this.toastrService.warning("Select Address Document Type");
        return;
      }

      if (this.selectedIDProof && this.selectedIdDocNo == '') {
        this.toastrService.warning("Insert ID Proof Document No.");
        return;
      } else if (!this.selectedIDProof && this.selectedIdDocNo != '') {
        this.toastrService.warning("Select ID Document Type");
        return;
      }
    }

    if (this.selectedIDProof == 'id_pancard') {
      var pan = this.selectedIdDocNo.match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)
      if (pan == null) {
        this.toastrService.warning('Invalid format of Pan Number')
        return;
      }
      const fourthChar = this.selectedIdDocNo.charAt(3).toUpperCase(); // Index 3 = 4th character
      if (this.userData?.account_type === 'Individual' && fourthChar !== 'P') {
        this.toastrService.warning('4th character of PAN must be "P" for Individual account type');
        return;
      }

      if (this.userData?.account_type !== 'Individual' && fourthChar === 'P') {
        this.toastrService.warning('4th character of PAN not be "P" for Company account type');
        return;
      }
    }
    if ((this.userData.account_type === 'Individual') && this.selectedAddressProof == 'aadhar_card' ) {
      var adhar = this.selectedAddDocNo.match(/^\d{12}$/);
      if (adhar == null) {
        this.toastrService.warning('Invalid format of Aadhar Number')
        return;
      }
    }
    let req = {
      "address_proofs": this.isAddKYCDone == false ? [
        {
          "data": "",
          "document_type": "Address Proof",
          "document_description": this.selectedAddressProof,
          "doc_number": this.selectedAddDocNo,
          "e-KYC": false
        }
      ] : [],
      "id_proofs": this.isIdKYCDone == false ? [
        {
          "data": "",
          "document_type": "ID Proof",
          "document_description": this.selectedIDProof,
          "doc_number": this.selectedIdDocNo,
          "e-KYC": false
        }
      ] : []
    }
    try {
      this.spinner.show()
      this.sub.add(this.apiService.uploadKYC(req).subscribe({
        next: (res: any) => {
          this.spinner.hide()
          if (res.success) {
            this.spinner.hide()
            this.toastrService.success("KYC Submit Successfully")
            this.getUserDetails()
          }
          else {
            this.spinner.hide()
            this.toastrService.warning(res.data.msg)
          }
        },
        error: () => {
          this.spinner.hide()
        },
        complete: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }

  resetFormGroup() {
    this.profileFormGroup = this.fb.group({
      mobile_number: [""],
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      email_id: ["", [Validators.required, Validators.pattern(this.regexService.Email)]],
      // location: ["", Validators.required],
      address: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required]
    })
  }
  getUserDetails() {
    let res = this.secureService.isLoggedIn();
    if (res) {
      this.sub.add(this.apiService.getUserData().subscribe({
        next: (response: any) => {
          this.userData = response["data"];
          this.bindUserProfile()
          // if (this.page == 'profilePage') {

            if (this.userData.state) {
              this.getState();
            }
          // }

          this.kycAddOne = this.userData?.address_one
          this.kycAddrTwo = this.userData?.address_two
          if (this.userData?.user_documents) {
            for (let i = 0; i < this.userData.user_documents?.length; i++) {
              if (this.userData.user_documents[i].document_description == "aadhar_card" || this.userData.user_documents[i].document_description == "adhar_card") {
                this.selectedAddressProof = this.userData.user_documents[i].document_description
                this.selectedAddDocNo = this.userData.user_documents[i].doc_number
                this.isAddKYCDone = this.userData.user_documents[i].e_kyc
              }
              else if (this.userData.user_documents[i].document_description == "id_pancard") {
                this.selectedIDProof = this.userData.user_documents[i].document_description
                this.selectedIdDocNo = this.userData.user_documents[i].doc_number
                this.isIdKYCDone = this.userData.user_documents[i].e_kyc
              }
              else { }
            }
          }

        },
        error: () => {
        },
      })
      );
    } else {
      this.toastrService.warning('Kindly Login');
      this.router.navigate(['/login/']);
    }
  }

  bindUserProfile() {
    let state;
    this.stateList?.forEach((e: any) => {
      if (e.name == this.userData.state) {
        this.profileFormGroup?.controls['state'].setValue(e.name);
        state = e
      }
    })

    if (this.userData.district) {
      this.profileFormGroup?.patchValue({ district: this.userData.district })
    }

    this.profileFormGroup?.patchValue({
      first_name: this.userData.first_name,
      last_name: this.userData.last_name,
      email_id: this.userData.email_id,
      state: state ? state.name : '',
      mobile_number: this.userData.mobile_number,
      district: this.userData.district ? this.userData.district : '',
      address: this.userData.address_one ? this.userData.address_one : ''

    }
    )
  }

  getState() {
    let data = {
      // lob: this.lob
    }
    this.sub.add(this.apiService.getStateList(data).subscribe({
      next: (res: any) => {
        this.stateList = res;
        if (!this.isAllowToEdit) {
          if (this.userData.state) {
            this.profileFormGroup?.patchValue({ state: this.userData.state })
            this.getDistrictList();
          }
        }
        else {
          if (this.userData.state) {
            this.getDistrictList();
          }

        }
      }
    }))
  }

  getDistrictList(item?) {
    this.districtList = [];
    let statecode;
    let state = this.profileFormGroup?.value.state;
    this.stateList?.forEach((e: any) => {
      if (e.name == state) {
        statecode = e.code;
      }
    });

    let dummyList = {};
    dummyList = {
      code: statecode,
      state: state,
    };

    let stateData = {
      state: dummyList,
      // lob: this.lob,
    };

    this.sub.add(this.apiService.getDistrictList(stateData).subscribe({
      next: (response: any) => {
        this.districtList = response;
        if (this.userData.district && !item) {
          this.profileFormGroup?.patchValue({ district: this.userData.district })
        }
        if (item) {
          this.profileFormGroup.patchValue({ district: "" })
        }
      },
      error: () => {
      },
      complete: () => {
        if (!item) {
          this.bindUserProfile();
        }
      }
    })
    );
  }
  uploadKfc() {
    let req = {
      "address_proofs": this.isAddKYCDone == false ? [
        {
          "data": "",
          "document_type": "Address Proof",
          "document_description": this.selectedAddressProof,
          "doc_number": this.selectedAddDocNo,
          "e-KYC": true
        }
      ] : [],
      "id_proofs": this.isIdKYCDone == false ? [
        {
          "data": "",
          "document_type": "ID Proof",
          "document_description": this.selectedIDProof,
          "doc_number": this.selectedIdDocNo,
          "e-KYC": true
        }
      ] : []
    }
    try {
      this.sub.add(this.apiService.uploadKYC(req).subscribe({
        next: (res: any) => {

          if (res.success) {
            this.updateUserAddress()
          }
          else {
            this.spinner.hide()
            this.toastrService.warning(res.data.msg)
          }
          // this.isShowThankyouPage = true
        },
        error: () => {
          this.spinner.hide()
        },
        complete: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  updateUserAddress() {
    var userAddrss = this.kycKarzaRes?.address
    this.kycAddr = userAddrss.buildingName + ',' + userAddrss.locality + ',' + userAddrss.streetName + ',' +
      userAddrss.city + '-' + userAddrss.pinCode
    this.kycAddOne = this.kycAddr.substring(0, 59),
      this.kycAddrTwo = this.kycAddr.substring(59, 119)
    let data = {
      "id": this.userData.id,
      "first_name": this.userData.first_name,
      "last_name": this.userData.last_name,
      "email_id": this.userData.email_id,
      "address_one": this.kycAddr.substring(0, 59),
      "address_two": this.kycAddr.substring(59, 119),
    }
    try {
      this.sub.add(this.apiService.updateCustomer(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.toastrService.success(res.data.msg);
            this.getUserDetails()
            this.spinner.hide()
          }
          else {
            this.toastrService.warning(res.data.msg)
            this.spinner.hide()

          }
        },
        error: () => {
          this.spinner.hide()
        },
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }


  masking(value) {
    // value = value.substring(0, 8).replace(/\d/g, '*') + value.substring(8, 12);
    this.selectedAddDocNo = value
  }

  redirect(data) {
    let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
    var currentUrl = '/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id;
    return currentUrl;
    // this.router.navigate(['/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);

  }
  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }

}
